var MATCH = require('./_wks')('match');
module.exports = function(KEY){
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch(e){
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch(f){ /* empty */ }
  } return true;
};


/** WEBPACK FOOTER **
 ** ./~/babel-polyfill/~/core-js/modules/_fails-is-regexp.js
 **/